import React from 'react';

// Jenn, 2026-10-09: "I would not complete this form. It has none of the
// branding for 365reset" — partners are not members, so they never see the
// Hub; every partner page gets the full 365reset frame instead (logo, colours,
// a real way to reach us), the same look as the affiliate dashboard.
export function PartnerShell({ children, right = null, wide = true, label = 'Partner Link' }) {
  return (
    <div className="min-h-screen bg-reset-cream flex flex-col">
      <header className="bg-reset-brownDeep">
        <div className={`${wide ? 'max-w-5xl' : 'max-w-2xl'} mx-auto w-full px-4 sm:px-6 py-4 flex items-center justify-between gap-4`}>
          <a href="https://365reset.com" className="flex items-center gap-3">
            <img src="/logo.png" alt="365reset" className="h-9 w-9" />
            <span className="font-serif italic text-2xl text-reset-cream leading-none">365reset</span>
          </a>
          <div className="flex items-center gap-4">
            <span className="text-xs font-bold uppercase tracking-wide text-reset-gold">{label}</span>
            {right}
          </div>
        </div>
      </header>
      <main className={`${wide ? 'max-w-5xl' : 'max-w-2xl'} mx-auto w-full px-4 sm:px-6 py-10 flex-1`}>{children}</main>
      <footer className="border-t border-reset-creamDark">
        <div className={`${wide ? 'max-w-5xl' : 'max-w-2xl'} mx-auto w-full px-4 sm:px-6 py-6 text-xs text-reset-grey flex flex-wrap gap-x-5 gap-y-2`}>
          <span>© 365reset</span>
          <a href="mailto:team365@365reset.com" className="underline">team365@365reset.com</a>
          <a href="https://365reset.com/privacy.html" className="underline">Privacy</a>
          <a href="https://365reset.com/terms.html" className="underline">Terms</a>
        </div>
      </footer>
    </div>
  );
}

export function Kicker({ children, className = 'text-reset-terracotta' }) {
  return <p className={`text-xs font-bold uppercase tracking-wide mb-2 ${className}`}>{children}</p>;
}
